'use strict';

// Adds accessibile labels to Query Block more link
let read_mores = document.querySelectorAll('.wp-block-post-excerpt__more-link');
read_mores.forEach( link => {
    let post_title = link.closest('.wp-block-post').querySelector('.wp-block-post-title').innerText;
    link.setAttribute( 'aria-label', 'Read more about ' + post_title );
});
